import classNames from "classnames";
import { upperFirst } from "lodash";
import { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import generalStyles from "../../editor-common/statics/styles/general-scss";
import generalRTLIgnoredStyles from "../../wix-rich-content-common/statics/styles/general.rtlignore-scss";
const stylesWithRTL = { ...generalStyles, ...generalRTLIgnoredStyles };
const useNodeContainerClasses = ({ editor, nodeId }) => {
  const { isMobile } = useContext(RicosContext);
  let isFocused = false;
  const selection = editor.state.selection;
  editor.state.doc.nodesBetween(selection.from, selection.to, (node) => {
    node.attrs.id === nodeId && (isFocused = true);
  });
  return classNames(stylesWithRTL.pluginContainer, {
    [stylesWithRTL.pluginContainerMobile]: isMobile,
    [stylesWithRTL.hasFocus]: isFocused,
    [stylesWithRTL.hideTextSelection]: !isFocused
  });
};
const useRootNodeContainerClasses = (containerData) => {
  const alignment = containerData?.alignment;
  const alignmentClassName = alignment ? stylesWithRTL[`align${upperFirst(alignment.toLowerCase())}`] : void 0;
  const size = containerData?.width?.size;
  const sizeClassName = size && size !== "FULL_WIDTH" ? stylesWithRTL[`size${upperFirst(size.toLowerCase())}`] : void 0;
  const textWrap = containerData?.textWrap;
  const textWrapClassName = textWrap ? void 0 : stylesWithRTL.textWrapNowrap;
  return classNames(alignmentClassName, sizeClassName, textWrapClassName);
};
export {
  useNodeContainerClasses,
  useRootNodeContainerClasses
};
//# sourceMappingURL=class-name-strategies.js.map
